import React from 'react';
import ProSidebarBase from './ProSidebarBase';
import type { NavItem } from './ProSidebarBase';

const adminItems: NavItem[] = [
  { label: '原価計算管理', to: '/admin/costaccounting/tokyo' },
  { label: 'レート管理', to: '/admin/rates' },
  { label: 'プロジェクト一覧', to: '/admin/projects' },
  { label: '社員一覧', to: '/admin/employees' },
  { label: '業務報告管理', to: '/admin/reports' },
  { label: '個別単価一覧', to: '/admin/unitprice' },
  { label: '工数管理', to: '/admin/manhours' },
  { label: '稼働管理', to: '/admin/workingtime' },
];

const AdminSidebar = () => {
  return <ProSidebarBase items={adminItems} />;
};

export default AdminSidebar;
